import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-college-anthem',
  templateUrl: './college-anthem.component.html',
  styleUrls: ['./college-anthem.component.scss']
})
export class CollegeAnthemComponent implements OnInit, OnDestroy {

  @ViewChild('audioPlayer', { static: false }) audioRef!: ElementRef<HTMLAudioElement>;

  audioSrc = '/assets/audio/A_Collage_Prayer-1.mp3';

  isPlaying = false;
  isMuted = false;
  currentTime = 0;
  duration = 0;
  volume = 1;

  get currentTimeFormatted(): string { return this.formatTime(this.currentTime); }
  get durationFormatted(): string    { return this.formatTime(this.duration); }
  get progressPercent(): number      { return this.duration ? (this.currentTime / this.duration) * 100 : 0; }

  ngOnInit(): void {}

  get audio(): HTMLAudioElement { return this.audioRef?.nativeElement; }

  onLoadedMetadata(): void { this.duration = this.audio.duration; }
  onTimeUpdate(): void     { this.currentTime = this.audio.currentTime; }
  onEnded(): void          { this.isPlaying = false; this.currentTime = 0; }

  togglePlay(): void {
    if (this.isPlaying) {
      this.audio.pause();
    } else {
      this.audio.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  toggleMute(): void {
    this.isMuted = !this.isMuted;
    this.audio.muted = this.isMuted;
  }

  seek(event: Event): void {
    const val = +(event.target as HTMLInputElement).value;
    this.audio.currentTime = (val / 100) * this.duration;
  }

  setVolume(event: Event): void {
    const val = +(event.target as HTMLInputElement).value;
    this.volume = val / 100;
    this.audio.volume = this.volume;
    this.isMuted = this.volume === 0;
  }

  skipBack(): void  { this.audio.currentTime = Math.max(0, this.audio.currentTime - 10); }
  skipForward(): void { this.audio.currentTime = Math.min(this.duration, this.audio.currentTime + 10); }

  private formatTime(s: number): string {
    if (!s || isNaN(s)) return '0:00';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, '0')}`;
  }

  ngOnDestroy(): void {
    if (this.audio) { this.audio.pause(); }
  }
}
